import { getAssetResources } from "@/shared/repository/mms-repository";
import { get } from "lodash-es";

type Props = {
	AssetId: number | null;
	setAssetAttachmentsList: Function;
	setAssetDrawings: Function;
	setAssetLOTOList: Function;
	setAssetPartsList: Function;
	setIsLoadingResourcesList: (isLoading: boolean) => void;
	setErrorResourcesList: (err: string) => void;
	setAssetResourcesMessage: (showMessage: boolean) => void;
};

export const useSearchAssetResources = ({
	AssetId,
	setAssetAttachmentsList,
	setAssetDrawings,
	setAssetLOTOList,
	setAssetPartsList,
	setIsLoadingResourcesList,
	setErrorResourcesList,
	setAssetResourcesMessage,
}: Props) => {
	return async () => {
		setIsLoadingResourcesList(true);
		const res = await getAssetResources(AssetId as number);
		if (res.ok) {
			const assetDrawingsList = get(res, "data.tables[0].rows", []);
			setAssetDrawings(assetDrawingsList);
			const assetLOTOList = get(res, "data.tables[1].rows", []);
			setAssetLOTOList(assetLOTOList);
			const assetPartsList = get(res, "data.tables[2].rows", []);
			setAssetPartsList(assetPartsList);
			const assetAttchmentsList = get(res, "data.tables[3].rows", []);
			setAssetAttachmentsList(assetAttchmentsList);
			if (
				assetDrawingsList.length == 0 &&
				assetLOTOList.length == 0 &&
				assetPartsList.length == 0 &&
				assetAttchmentsList.length == 0
			)
				setAssetResourcesMessage(true);

			setIsLoadingResourcesList(false);
		} else {
			setIsLoadingResourcesList(false);
			setErrorResourcesList(res.message);
		}
	};
};
